import React from 'react';
import Lightningsuco from "./Lightningsuco";

const LightningProbability = () => {
  return (
    <div>
        <Lightningsuco/>
    </div>
  );
};

export default LightningProbability;
